import { render, staticRenderFns } from "./infoPopup.vue?vue&type=template&id=64b282f5&scoped=true"
import script from "./infoPopup.vue?vue&type=script&lang=js"
export * from "./infoPopup.vue?vue&type=script&lang=js"
import style0 from "./infoPopup.vue?vue&type=style&index=0&id=64b282f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b282f5",
  null
  
)

export default component.exports